import MyNemi from './MyNemi.svelte';
const targetMyNemi = document.getElementById('my-nemi');
if (targetMyNemi) {
    const myNemi = new MyNemi({
        target: targetMyNemi,
        props: {},
    });
}
